import { isNumber } from 'highcharts';
import styled from 'styled-components';

import { colors, radii } from '@gbs-monorepo-packages/styles';

interface IInputTextAreaProps {
  rows?: number;
  $resize: boolean;
}

export const InputTextArea = styled.textarea<IInputTextAreaProps>`
  -webkit-appearance: none;
  appearance: none;
  background-color: ${colors.white300};
  border-radius: ${radii.px};
  border: none;
  color: ${colors.text};
  flex-grow: 1;
  font-size: 1rem;
  height: ${({ rows }) =>
    isNumber(rows) ? `${Number(rows) * 1.1}rem` : '3.25rem'};
  line-height: 1.1;
  outline: none;
  padding: 1rem;
  width: 100%;

  resize: ${({ $resize }) => ($resize ? 'vertical' : 'none')};

  &::placeholder {
    color: ${colors.inputPlaceholder};
  }

  &:disabled {
    background-color: transparent;
    cursor: not-allowed;
  }

  @media (max-width: 337px) {
    width: 100%;
  }
`;
